import { render, staticRenderFns } from "./item5.vue?vue&type=template&id=201abe12&scoped=true"
import script from "./item5.vue?vue&type=script&lang=js"
export * from "./item5.vue?vue&type=script&lang=js"
import style0 from "./item5.vue?vue&type=style&index=0&id=201abe12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201abe12",
  null
  
)

export default component.exports